import { TIsDisabled, TIsRegistered } from "./types";

export const DEFAULT_MAX_MENTORS = 10;

export type TMentorShiftScheduleEvent = {
  id: number;
  title: string;
  start: moment.Moment;
  end: moment.Moment;
  displayedStart: string;
  displayedEnd: string;
  numberOfBlocks: number;
  blocksFromTop: number;
  overlapColumn: number;
  registeredMentors: number;
  maxMentors: number;
  isRegistered?: TIsRegistered;
  isDisableRegistered?: TIsDisabled;
};

export enum DISABLE_REASONS {
  NO_SPOTS_LEFT,
  TIME_CONFLICT,
  MIN_SIGN_UPS,
  NOT_MATCHING_PRIMARY_ROLE,
}

export const generateDisableReasonToolTip = (
  disable: DISABLE_REASONS,
  details?: string
): string => {
  switch (disable) {
    case DISABLE_REASONS.NO_SPOTS_LEFT:
      return "No more spots left!";
    case DISABLE_REASONS.TIME_CONFLICT:
      return "Time conflict with " + details;
    case DISABLE_REASONS.MIN_SIGN_UPS:
      return "Please sign up for your 2 primary shifts first";
    case DISABLE_REASONS.NOT_MATCHING_PRIMARY_ROLE:
      return "You can only sign up for " + details + " and Supplementary roles";
    default:
      return "";
  }
};

export const IS_REGISTRATION_OPEN = false;
